import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { LineTrend, HBarChart } from "@/components/admin/Charts";
import { Users, PhoneCall, MessageCircle, Car, Package as PkgIcon, GalleryHorizontal, Calendar, Eye } from "lucide-react";

const STAT = [
  { key: "total_leads", label: "Total Leads", icon: Users },
  { key: "today_leads", label: "Today", icon: Calendar },
  { key: "month_leads", label: "This Month", icon: Calendar },
  { key: "call_clicks", label: "Call Clicks", icon: PhoneCall },
  { key: "whatsapp_clicks", label: "WhatsApp Clicks", icon: MessageCircle },
  { key: "package_views", label: "Package Views", icon: PkgIcon },
  { key: "vehicle_views", label: "Vehicle Views", icon: Car },
  { key: "gallery_views", label: "Gallery Views", icon: GalleryHorizontal },
  { key: "homepage_visitors", label: "Homepage Visits", icon: Eye },
];

export default function AdminDashboard() {
  const { data } = useQuery({ queryKey: ["dashboard"], queryFn: () => api.get("/admin/dashboard").then((r) => r.data) });
  const totals = data?.totals || {};
  return (
    <div className="space-y-8">
      <div>
        <div className="text-xs uppercase tracking-[0.24em] text-amber-600">Dashboard</div>
        <h1 className="font-display text-4xl text-slate-950 mt-1">Overview</h1>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-5 gap-4">
        {STAT.map((s) => (
          <Card key={s.key} className="border border-slate-200" data-testid={`stat-${s.key}`}>
            <CardContent className="p-5">
              <div className="flex items-center justify-between">
                <div className="text-xs uppercase tracking-[0.2em] text-slate-500">{s.label}</div>
                <s.icon className="w-4 h-4 text-amber-600" />
              </div>
              <div className="mt-3 font-display text-3xl text-slate-950">{totals[s.key] ?? 0}</div>
            </CardContent>
          </Card>
        ))}
      </div>

      <div className="grid lg:grid-cols-3 gap-6">
        <Card className="lg:col-span-2 border border-slate-200">
          <CardContent className="p-6">
            <div className="text-sm font-medium text-slate-700 mb-4">Lead trend (14 days)</div>
            <div className="h-56"><LineTrend data={data?.lead_trend || []} /></div>
          </CardContent>
        </Card>
        <Card className="border border-slate-200">
          <CardContent className="p-6">
            <div className="text-sm font-medium text-slate-700 mb-4">Popular packages</div>
            <HBarChart data={data?.popular_packages || []} />
          </CardContent>
        </Card>
      </div>

      <div className="grid lg:grid-cols-2 gap-6">
        <Card className="border border-slate-200">
          <CardContent className="p-6">
            <div className="text-sm font-medium text-slate-700 mb-4">Popular vehicles</div>
            <HBarChart data={data?.popular_vehicles || []} color="#334155" />
          </CardContent>
        </Card>
        <Card className="border border-slate-200">
          <CardContent className="p-6">
            <div className="text-sm font-medium text-slate-700 mb-4">Popular destinations</div>
            <HBarChart data={data?.popular_destinations || []} color="#334155" />
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
